import React from "react";

export default function Settings() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Organization Profile</div>
        <div className="grid grid-cols-1 gap-2 text-sm">
          <label className="grid gap-1">
            <span className="opacity-70">Display name</span>
            <input className="bg-black/20 border border-white/20 rounded-xl px-3 py-2" defaultValue="Acme Industries" />
          </label>
          <label className="grid gap-1">
            <span className="opacity-70">Location</span>
            <input className="bg-black/20 border border-white/20 rounded-xl px-3 py-2" defaultValue="London" />
          </label>
        </div>
        <div className="mt-3">
          <button className="px-4 py-2 rounded-xl border border-white/20 bg-white/10 hover:bg-white/15 text-sm">
            Save
          </button>
        </div>
      </div>

      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">SSO Configuration</div>
        <div className="text-sm opacity-80 mb-2">
          Upload SAML metadata or OIDC details. Only org admins may modify.
        </div>
        <div className="flex gap-2">
          <button className="px-3 py-2 rounded-xl border border-white/20 bg-white/10 hover:bg-white/15 text-sm">
            Upload Metadata XML
          </button>
          <button className="px-3 py-2 rounded-xl border border-white/20 bg-white/10 hover:bg-white/15 text-sm">
            Configure OIDC
          </button>
        </div>
      </div>
    </div>
  );
}
